import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

function Navbar({ galleryOnly }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 backdrop-blur-xl ${scrolled ? "bg-black/90 shadow-2xl" : "bg-black/70"}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
        <Link
          to="/"
          className="text-2xl font-black bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent hover:scale-110 transition-transform"
          onClick={() => setMenuOpen(false)}
        >
          ANDREW POUDEL
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8">
          {galleryOnly ? (
            <Link
              to="/"
              className="text-gray-300 hover:text-green-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider"
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
          ) : (
            [
              "Home",
              "aboutme",
              "commitments",
              "works",
              "gallery",
              "contact",
            ].map((item) =>
              item === "gallery" ? (
                <Link
                  key={item}
                  to="/gallery"
                  className="text-gray-300 hover:text-green-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider"
                  onClick={() => setMenuOpen(false)}
                >
                  Gallery
                </Link>
              ) : item === "Home" ? (
                <Link
                  key={item}
                  to="/"
                  className="text-gray-300 hover:text-green-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider"
                  onClick={() => setMenuOpen(false)}
                >
                  Home
                </Link>
              ) : (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(" ", "")}`}
                  className="text-gray-300 hover:text-green-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider"
                >
                  {item}
                </a>
              ),
            )
          )}
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white hover:text-green-400 transition-colors"
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-gradient-to-b from-black/95 to-black/80 backdrop-blur-md border-t-2 border-green-500/30">
          {galleryOnly ? (
            <Link
              to="/"
              className="block px-4 py-4 text-gray-300 hover:text-green-400 hover:bg-green-500/10 transition-all border-b border-gray-800 font-semibold uppercase tracking-wider"
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
          ) : (
            [
              "Home",
              "Case Studies",
              "Testimonials",
              "Works",
              "Gallery",
              "Contact",
            ].map((item) =>
              item === "Gallery" ? (
                <Link
                  key={item}
                  to="/gallery"
                  className="block px-4 py-4 text-gray-300 hover:text-green-400 hover:bg-green-500/10 transition-all border-b border-gray-800 font-semibold uppercase tracking-wider"
                  onClick={() => setMenuOpen(false)}
                >
                  Gallery
                </Link>
              ) : item === "Home" ? (
                <Link
                  key={item}
                  to="/"
                  className="block px-4 py-4 text-gray-300 hover:text-green-400 hover:bg-green-500/10 transition-all border-b border-gray-800 font-semibold uppercase tracking-wider"
                  onClick={() => setMenuOpen(false)}
                >
                  Home
                </Link>
              ) : (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(" ", "")}`}
                  className="block px-4 py-4 text-gray-300 hover:text-green-400 hover:bg-green-500/10 transition-all border-b border-gray-800 font-semibold uppercase tracking-wider"
                  onClick={() => setMenuOpen(false)}
                >
                  {item}
                </a>
              ),
            )
          )}
        </div>
      )}
    </nav>
  );
}

export default Navbar;
